import * as Yup from 'yup'
import { Form,Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormControl,CustomFormSelect } from '../../../../StyledComponents';

export const Schema = (settings) => Yup.object().shape({
     becomingAwareThrough: Yup.string().required("Angabe ist erforderlich"),
     becomingAwareThroughOther: Yup.string()
        .when('becomingAwareThrough', {
            is: 'Sonstiges',
            then: Yup.string().required("Angabe ist erforderlich"),
    }),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
        <Row className="mb-3">
            <Form.Group controlId="formBecomingAwareThrough">
                <Form.Label>Aufmerksam geworden durch*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                <option value="">Bitte auswählen...</option>
                {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                   {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>
            {values.becomingAwareThrough === "Sonstiges" && <Form.Group  controlId="formBecomingAwareThroughOther">
                <CustomFormControl
                    colors={colors}
                    placeholder="Aufmerksam Details"
                    type="text"
                    name="becomingAwareThroughOther"
                    value={values.becomingAwareThroughOther}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.becomingAwareThroughOther && !errors.becomingAwareThroughOther}
                    isInvalid={touched.becomingAwareThroughOther && errors.becomingAwareThroughOther}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThroughOther}
                </Form.Control.Feedback>
            </Form.Group>}
            </Row>
        
        </>
    );
};